const categoriesQuery = require('./categories');
const latestArticlesQuery = require('./latestArticles');
const guidesArticlesQuery = require('./guidesArticles');
const categoryGuideArticlesQuery = require('./categoryGuideArticles');
const relatedArticlesQuery = require('./relatedArticles');
const listviewArticlesQuery = require('./listviewArticles');
const articleQuery = require('./article');

module.exports = {
  categoriesQuery,
  latestArticlesQuery,
  guidesArticlesQuery,
  categoryGuideArticlesQuery,
  relatedArticlesQuery,
  listviewArticlesQuery,
  articleQuery,
};
